import { TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { PrintStatementTablePropsType } from "../../../types/container.type";
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";
import { formatDate } from "../../../helpers/dateFormatter";

export const PrintStatementTable: React.FC<PrintStatementTablePropsType> = ({ rows, headers }) => {
	return (
		<BaseTable headers={headers}>
			<TableBody>
				{rows?.map((row, index) => {
					return (
						<TableRow key={index}>
							<TableCell>{formatDate(row?.createdAt, false)}</TableCell>
							<TableCell>{row?.description}</TableCell>
							<TableCell>
								{formatAmountDisplay(row?.entryType === "dr" ? row?.amount : 0)}
							</TableCell>
							<TableCell>
								{formatAmountDisplay(row?.entryType === "cr" ? row?.amount : 0)}
							</TableCell>
							<TableCell>{formatAmountDisplay(row?.balance ?? 0)}</TableCell>
						</TableRow>
					);
				})}
			</TableBody>
		</BaseTable>
	);
};
